import {
  jobScopeParamsFromWeekSelection,
  periodScopeParamsFromWeekSelection,
  type WeekSelectorValue,
} from '@/components/shared/WeekSelector';
import type { BrandMergeGroup } from '@/types/database-schema';
import { buildBrandScopeSearchParams } from './brandScope';

export const LEADERBOARD_DISCOVERY_LIMIT = 200;

/** Shared by the leaderboard and Explorer: query scope and destination must agree. */
export function buildLeaderboardDiscoveryParams({
  weekSelection,
  jobsTrustworthy,
  engine,
  promptIds,
  explicitPromptIds,
  promptGroupId,
  promptGroupOrigin,
  promptSubtopicId,
  brandGroups,
}: {
  weekSelection: WeekSelectorValue;
  jobsTrustworthy: boolean;
  engine?: string;
  promptIds: string[];
  explicitPromptIds?: string[];
  promptGroupId?: string;
  promptGroupOrigin?: 'local' | 'shared';
  promptSubtopicId?: string;
  brandGroups: BrandMergeGroup[];
}) {
  const scope =
    weekSelection === 'all' || !jobsTrustworthy
      ? {}
      : (periodScopeParamsFromWeekSelection(weekSelection) ??
        jobScopeParamsFromWeekSelection(weekSelection));
  return {
    ...scope,
    enabled: jobsTrustworthy,
    engine: engine || undefined,
    prompt_group_id: promptGroupId,
    prompt_group_origin: promptGroupOrigin === 'shared' ? ('shared' as const) : undefined,
    ...(promptSubtopicId ? { prompt_subtopic_id: promptSubtopicId } : {}),
    prompt_ids: explicitPromptIds?.length
      ? explicitPromptIds
      : !promptGroupId && promptIds.length
        ? promptIds
        : undefined,
    brand_groups: brandGroups,
    limit: LEADERBOARD_DISCOVERY_LIMIT,
  };
}

export function buildLeaderboardBrandHref(
  brandSlug: string,
  scope: Parameters<typeof buildBrandScopeSearchParams>[0],
  subPath = ''
) {
  const search = buildBrandScopeSearchParams(scope).toString();
  const encodedSlug = encodeURIComponent(brandSlug);
  const basePath =
    subPath === '/weekly-report' || subPath === '/fan-outs'
      ? `/app/brands/${encodedSlug}`
      : `/app/ai-search/${encodedSlug}`;
  return `${basePath}${subPath}${search ? `?${search}` : ''}`;
}
